import { render, staticRenderFns } from "./organization-selector.vue?vue&type=template&id=97456a70&scoped=true&"
import script from "./organization-selector.vue?vue&type=script&lang=js&"
export * from "./organization-selector.vue?vue&type=script&lang=js&"
import style0 from "./organization-selector.vue?vue&type=style&index=0&id=97456a70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97456a70",
  null
  
)

export default component.exports